import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Username:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Created:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "User Type:", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Log Out")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitleComponent = _resolveComponent("PageTitleComponent")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_UserMessageComponent = _resolveComponent("UserMessageComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_PageContentComponent = _resolveComponent("PageContentComponent")!

  return (_openBlock(), _createBlock(_component_PageContentComponent, { class: "user-view" }, {
    default: _withCtx(() => [
      _createVNode(_component_PageTitleComponent, { title: "Your User" }),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_LoadingComponent, { message: "Loading Your User Details" })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_UserMessageComponent, { details: _ctx.userMessage }, null, 8, ["details"]),
      (_ctx.user !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", null, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.user.username), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.displayCreatedAt) + " (" + _toDisplayString(_ctx.displayCreatedAtDifference) + ") ", 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.displayUserType), 1)
            ]),
            _createVNode(_component_ButtonComponent, { onClick: _ctx.onLogOut }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}